import React, {useEffect, useState} from 'react';
import * as yup from 'yup';
import {t} from 'react-switch-lang';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {
  getExternalizationByCycleId,
  updateExternalization,
} from '../../../../../services/externalizations/externalizationService';
import {Toast} from '../../../../../utils/sweetAlert';
import {Col, Row} from 'react-bootstrap';
import Label from 'reactstrap/lib/Label';
import InputText from '../../../../../components/FormFields/InputText';
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import returnDataTitle from '../../../../../components/modals/ModalData/DataTitle';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import Swal from 'sweetalert2';
import SelectList from '../../../../../components/FormFields/select/SelectList';
import {
  allowedNextStatuses,
  externalizationStatuses,
  yesNoOptions,
} from '../../../../../utils/externalizationFormOptions';
import {useUserContext} from '../../../../../contexts/UserContext';
import roles from '../../../../../utils/roles';
import {getExitStrategyForm} from '../../../../../services/externalizations/exitStrategyService';

const EditExternalization = (props) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [defaultData, setDefaultData] = useState()
  const [exitStrategyData, setExitStrategyData] = useState()
  const externalizationScheme = yup.object().shape({
    contractSubject: yup
      .string()
      .trim()
      .required(t('message.fieldRequired'))
      .max(255, `${t('message.max', {max: 255})}`)
      .min(2, `${t('message.min', {min: 2})}`),
    serviceProvider: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
    status: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
    externalizationForSubcontractor: yup
      .object()
      .nullable()
      .required(t('message.fieldRequired')),
  });
  const methods = useForm({
    resolver: yupResolver(externalizationScheme),
  });
  const {handleSubmit, errors, reset} = methods;
  const userAuthorities = useUserContext().authorities;
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
const userInChargeForExternalization = userAuthorities.some((r) =>
  r.includes(roles.role_user_in_charge_for_externalization)
);
  const currentStatus = defaultData?.status;
  const allowedNext = allowedNextStatuses[currentStatus] || [];
  const filteredOptions = externalizationStatuses.filter(option => {
const isAllowed = allowedNext.includes(option?.value);
    if (!isAllowed) return false;
    if (
      ['ASSESSMENT_COMPLETED', 'REASSESSMENT_COMPLETED'].includes(option?.value) &&
      !defaultData?.allFormsVerified
    ) {
      return false;
    }
    if (option?.value === 'EXIT_STRATEGY_ACTIVATED') {
      if (defaultData?.critical === false || defaultData?.critical === null) {
        return false;
      } else if (defaultData?.critical === true) {
        if (
          !exitStrategyData?.length ||
          !['VERIFIED', 'DRAFT'].includes(exitStrategyData?.[0]?.verificationStatus)
        ) {
          return false;
        }
      }
    }

    return true;
    });
  useEffect(()=> {
    getExternalizationByCycleId(props?.data?.id).then(r=>{
      setDefaultData(r?.data)
    })
    getExitStrategyForm(props?.data?.currentCycleId).then(r=>{
      setExitStrategyData(r?.data)
    })
  }, [props?.data?.id])
  const submitForm = (data) =>{
    setIsButtonDisabled(true);
    const dataToSubmit = {
      id: props?.data.id,
      contractSubject: data?.contractSubject,
      serviceProvider: {id: data?.serviceProvider?.value},
      status: data?.status?.value,
      externalizationForSubcontractor: data?.externalizationForSubcontractor?.value
    };
    updateExternalization(dataToSubmit, props?.data.id).then((res) => {
      if (res?.status === 200) {
        Toast.fire({
          title: t('departments.message.updateSuccess', {
            entity: t('externalization.riskProponentForm.addExternalization'),
          }),
          icon: 'success',
        });
        props.onClose();
        setIsButtonDisabled(false)
      }
      window.location.reload()
      setIsButtonDisabled(false);
    }).catch((err) => {
      if (err?.response?.data?.code === 'externalization-already-exists') {
        Swal.fire({
          text: t('message.externalizationAlreadyExists'),
          icon: 'error',
        });
        setIsButtonDisabled(false)
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    })
  };

  useEffect(() => {
    reset({
      externalizationForSubcontractor: typeof defaultData?.externalizationForSubcontractor === 'boolean'
          ? yesNoOptions.find(
            (status) => status.value === defaultData?.externalizationForSubcontractor
          )
          : null,
      status: defaultData?.status
        ? externalizationStatuses.find(
          (option) => option?.value === defaultData?.status
        )
        : null,
    serviceProvider: defaultData?.serviceProviderId ? {label:defaultData?.serviceProviderName,
      value: defaultData?.serviceProviderId} : null
    })
  },[defaultData])
  const handleCancel = (e) => {
    e.preventDefault();
    props.onClose();
  };
  return (
    <Modal isOpen={true} toggle={props.onClose}
           className="modal-lg" backdrop="static">
      <ModalHeader toggle={props.onClose}>
        <b>
          {t('buttons.editBtn')}
          <span>{returnDataTitle(defaultData?.id, defaultData)}</span>
        </b>
      </ModalHeader>
      <ModalBody>
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="contractSubject"> {t("externalization.riskProponentForm.contractSubject")}</Label>
            <InputText
              type="text"
              id="contractSubject"
              name="contractSubject"
              defaultValue={defaultData?.contractSubject}
              className={
                "form-control " +
                (errors.contractSubject !== undefined ? "error-field" : "")
              }
              placeholder={t("externalization.riskProponentForm.placeholder.contractSubject")}
              disabled={!userInChargeForExternalization}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="serviceProvider" className={"labelClass"}>
              {" "}
              {t("externalization.riskProponentForm.serviceProvider")}
            </Label>
            <SelectInfinite
              api={`/service-providers`}
              name="serviceProvider"
              labelKey={'name'}
              className={errors.serviceProvider && "error-field"}
              placeholder={t("externalization.riskProponentForm.placeholder.serviceProvider")}
              queryKeys={"name.contains"}
              isDisabled={true}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="serviceProvider" className={"labelClass"}>
              {t("externalization.externalizationForSubcontractor")}
            </Label>
            <SelectList
              name="externalizationForSubcontractor"
              className="select"
              placeholder={t( 'externalization.placeholder.externalizationForSubcontractor')}
              options={yesNoOptions}
              isClearable
              isDisabled={!userInChargeForExternalization}
            />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm={12}>
            <Label for="serviceProvider" className={"labelClass"}>
              {t("externalization.externalizationStatus.externalizationStatus")}
            </Label>
            <SelectList
              name="status"
              className="select"
              placeholder={t( 'externalization.placeholder.externalizationStatus.externalizationStatus')}
              options={filteredOptions}
              isClearable={false}
              isDisabled={!userRiskSector}
            />
          </Col>
        </Row>
        <Row className="submit-buttons-container mx-0">
          <Col sm={12} className="text-right px-0">
            <div className="submit">
              <button
                className="primary cancel"
                type="reset"
                onClick={(e) => handleCancel(e)}>
                {t("buttons.cancelBtn")}
              </button>
              <button className="primary">
                {t("buttons.saveBtn")}
              </button>
            </div>
          </Col>
        </Row>
      </form>
    </FormProvider>
      </ModalBody>
    </Modal>
  );
};


export default EditExternalization;